import $ from 'jquery';
import VideoMediaMatchService from '../mediaMatch';

const VideoThumnailService = {};

function getDailymotionThumbnail(url, callback) {
  var id,
    match = url.match(VideoMediaMatchService.config.dailymotion.matcher);

  if (match) {
    id = match[1];

    $.getJSON('//api.dailymotion.com/video/' + id + '?callback=?', { fields: 'thumbnail_720_url' })
      .fail(function () {
        callback('//www.dailymotion.com/thumbnail/video/' + id);
      })
      .done(function (data) {
        callback(data.thumbnail_720_url);
      });
  } else {
    callback(null);
  }
}

function getVimeoThumbnail(url, callback) {
  var id,
    match = url.match(VideoMediaMatchService.config.vimeo.matcher);

  if (match) {
    id = match[1];
    fetch(`//vimeo.com/api/v2/video/${id}.json`)
      .then((response) => {
        return response.json();
      })
      .then((thumbnailInfo) => {
        callback(thumbnailInfo[0].thumbnail_large);
      })
      .catch((e) => {
        /* fail silently */
      });
  } else {
    callback(null);
  }
}

function getYoutubeThumbnail(url, callback) {
  var id,
    match = url.match(VideoMediaMatchService.config.youtube.matcher);

  if (match) {
    id = match[3];
    callback('//img.youtube.com/vi/' + id + '/0.jpg');
  } else {
    callback(null);
  }
}

VideoThumnailService.getVideoThumbnailUrl = function (url) {
  var deferred = $.Deferred(),
    type = VideoMediaMatchService.getTypeFromUrl(url),
    callback = function (url) {
      deferred.resolve(url);
    };

  switch (type) {
    case 'youtube':
      getYoutubeThumbnail(url, callback);
      break;

    case 'vimeo':
      getVimeoThumbnail(url, callback);
      break;

    case 'dailymotion':
      getDailymotionThumbnail(url, callback);
      break;

    case 'channel9':
      callback('/bundles/app/images/channel9/apprendre_a_code_thumb.png');
      break;

    default:
      callback(null);
  }

  return deferred;
};

export default VideoThumnailService;
